import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { spacing16 } from "@churchofjesuschrist/eden-style-constants";
const Root = styled.div.withConfig({
  componentId: "sc-nddjfn-0"
})(["padding:0 ", ";"], spacing16);
const Content = styled.div.withConfig({
  componentId: "sc-nddjfn-1"
})(["max-width:42rem;margin:0 auto;"]);

const ReadWidth = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Root, props, /*#__PURE__*/React.createElement(Content, null, children));
};

ReadWidth.propTypes = {
  /** Children to be constrained */
  children: PropTypes.node.isRequired
};
export default ReadWidth;